export default "__VITE_ASSET__DvOMCFop__"